// extracted by mini-css-extract-plugin
export default {"button":"br1fCW","as-link":"a6QHfN","asLink":"a6QHfN","loading":"mlU8zd","indicator":"_FURd4"};